// extracted by mini-css-extract-plugin
export default {"root":"CircularProgress_root__CyppR","loadingAnimation":"CircularProgress_loadingAnimation__9wDv8"};